import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import NavBar from './NavBar';
import { useAuth0 } from '../helpers/react-auth0-spa';

// @ts-ignore
const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: path }
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  const render = (props: any) => {
    return isAuthenticated === true ? <Component {...props} /> : null;
  };

  return (
    <>
      <NavBar {...rest} />
      <Route exact path={path} render={render} {...rest} />
    </>
  );
};

export default PrivateRoute;
